import {
	VHE_AUXILIAR_PROVIDERS_LIST,
	VHE_AUXILIAR_PROVIDERS_CREATE,
	VHE_AUXILIAR_PROVIDERS_EDIT,
	VHE_AUXILIAR_CLIENTTYPES_LIST,
	VHE_AUXILIAR_CLIENTTYPES_CREATE,
	VHE_AUXILIAR_CLIENTTYPES_EDIT,
	VHE_AUXILIAR_INSTALLATIONTYPES_LIST,
	VHE_AUXILIAR_INSTALLATIONTYPES_CREATE,
	VHE_AUXILIAR_INSTALLATIONTYPES_EDIT,
	VHE_AUXILIAR_PRODUCTS_LIST,
	VHE_AUXILIAR_PRODUCTS_CREATE,
	VHE_AUXILIAR_PRODUCTS_EDIT,
	VHE_AUXILIAR_DOCUMENTTYPES_LIST,
	VHE_AUXILIAR_DOCUMENTTYPES_CREATE,
	VHE_AUXILIAR_DOCUMENTTYPES_EDIT,
	VHE_AUXILIAR_INSPECTIONMADEBY_LIST,
	VHE_AUXILIAR_INSPECTIONMADEBY_CREATE,
	VHE_AUXILIAR_INSPECTIONMADEBY_EDIT,
	VHE_AUXILIAR_LEVEL1_LIST,
	VHE_AUXILIAR_LEVEL1_CREATE,
	VHE_AUXILIAR_LEVEL1_EDIT,
	VHE_AUXILIAR_LEVEL2_LIST,
	VHE_AUXILIAR_LEVEL2_CREATE,
	VHE_AUXILIAR_LEVEL2_EDIT,
	VHE_AUXILIAR_LEVEL3_LIST,
	VHE_AUXILIAR_LEVEL3_CREATE,
	VHE_AUXILIAR_LEVEL3_EDIT,
	VHE_AUXILIAR_LEVEL4_LIST,
	VHE_AUXILIAR_LEVEL4_CREATE,
	VHE_AUXILIAR_LEVEL4_EDIT,
} from '../../constants'

export default [
	// PROVEEDORES
	{
		path: VHE_AUXILIAR_PROVIDERS_LIST,
		name: 'list_auxiliar_providers_vhe',
		component: () => import('@/views/vhe/auxiliars_providers/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de Proveedores',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado de Proveedores',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_PROVIDERS_CREATE,
		name: 'create_auxiliar_providers_vhe',
		component: () => import('@/views/vhe/auxiliars_providers/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo proveedor',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Proveedores',
					to: VHE_AUXILIAR_PROVIDERS_LIST,
				},
				{
					text: 'Añadir nuevo proveedor',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_PROVIDERS_EDIT}/:id`,
		name: 'auxiliar_providers_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_providers/form/formView.vue'),
		meta: {
			pageTitle: 'Proveedores',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Proveedores',
					to: VHE_AUXILIAR_PROVIDERS_LIST,
				},
				{
					text: 'Editar Proveedor',
					active: true,
				},
			],
		},
	},
	// END PROVEEDORES

	// 	TIPOS DE CLIENTES
	{
		path: VHE_AUXILIAR_CLIENTTYPES_LIST,
		name: 'list_auxiliar_clientTypes_vhe',
		component: () => import('@/views/vhe/auxiliars_clientTypes/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de tipos de clientes',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado de tipos de clientes',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_CLIENTTYPES_CREATE,
		name: 'create_auxiliar_clientTypes_vhe',
		component: () => import('@/views/vhe/auxiliars_clientTypes/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo tipo de cliente',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Tipo de cliente',
					to: VHE_AUXILIAR_CLIENTTYPES_LIST,
				},
				{
					text: 'Añadir nuevo tipo de cliente',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_CLIENTTYPES_EDIT}/:id`,
		name: 'auxiliar_clientTypes_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_clientTypes/form/formView.vue'),
		meta: {
			pageTitle: 'Editar Tipo de cliente',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Tipo de cliente',
					to: VHE_AUXILIAR_CLIENTTYPES_LIST,
				},
				{
					text: 'Editar Tipo de cliente',
					active: true,
				},
			],
		},
	},
	// 	END TIPOS DE CLIENTES

	// 	TIPOS DE INSTALACIONES
	{
		path: VHE_AUXILIAR_INSTALLATIONTYPES_LIST,
		name: 'list_auxiliar_installationTypes_vhe',
		component: () => import('@/views/vhe/auxiliars_installationTypes/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de tipos de instalaciones',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado de tipos de instalaciones',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_INSTALLATIONTYPES_CREATE,
		name: 'create_auxiliar_installationTypes_vhe',
		component: () => import('@/views/vhe/auxiliars_installationTypes/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo tipo de instalación',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Tipo de instalación',
					to: VHE_AUXILIAR_INSTALLATIONTYPES_LIST,
				},
				{
					text: 'Añadir nuevo tipo de instalación',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_INSTALLATIONTYPES_EDIT}/:id`,
		name: 'auxiliar_installationTypes_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_installationTypes/form/formView.vue'),
		meta: {
			pageTitle: 'Editar Tipo de instalación',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Tipo de instalación',
					to: VHE_AUXILIAR_INSTALLATIONTYPES_LIST,
				},
				{
					text: 'Editar Tipo de instalación',
					active: true,
				},
			],
		},
	},
	// 	END TIPOS DE INSTALACIONES

	// 	PRODUCTOS
	{
		path: VHE_AUXILIAR_PRODUCTS_LIST,
		name: 'list_auxiliar_products_vhe',
		component: () => import('@/views/vhe/auxiliars_products/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de productos',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado de productos',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_PRODUCTS_CREATE,
		name: 'create_auxiliar_products_vhe',
		component: () => import('@/views/vhe/auxiliars_products/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo producto',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Productos',
					to: VHE_AUXILIAR_PRODUCTS_LIST,
				},
				{
					text: 'Añadir nuevo producto',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_PRODUCTS_EDIT}/:id`,
		name: 'auxiliar_products_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_products/form/formView.vue'),
		meta: {
			pageTitle: 'Editar un producto',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Productos',
					to: VHE_AUXILIAR_PRODUCTS_LIST,
				},
				{
					text: 'Editar producto',
					active: true,
				},
			],
		},
	},
	//  END PRODUCTOS

	// 	TIPO DE DOCUMENTOS
	{
		path: VHE_AUXILIAR_DOCUMENTTYPES_LIST,
		name: 'list_auxiliar_documentTypes_vhe',
		component: () => import('@/views/vhe/auxiliars_documentTypes/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de tipos de documentos',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado de tipos de documentos',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_DOCUMENTTYPES_CREATE,
		name: 'create_auxiliar_documentTypes_vhe',
		component: () => import('@/views/vhe/auxiliars_documentTypes/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo tipo de documento',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Tipos de documentos',
					to: VHE_AUXILIAR_DOCUMENTTYPES_LIST,
				},
				{
					text: 'Añadir nuevo tipo de documento',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_DOCUMENTTYPES_EDIT}/:id`,
		name: 'auxiliar_documentTypes_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_documentTypes/form/formView.vue'),
		meta: {
			pageTitle: 'Editar un tipo de documento',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Productos',
					to: VHE_AUXILIAR_DOCUMENTTYPES_LIST,
				},
				{
					text: 'Editar tipo de documento',
					active: true,
				},
			],
		},
	},
	//  END TIPO DE DOCUMENTOS

	// 	INSPECCIÓN REALIZADA POR
	{
		path: VHE_AUXILIAR_INSPECTIONMADEBY_LIST,
		name: 'list_auxiliar_inspectionMadeBy_vhe',
		component: () => import('@/views/vhe/auxiliars_inspectionMadeBy/list/listView.vue'),
		meta: {
			pageTitle: 'Listado de inspecciones realizadas',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado de inspecciones realizadas',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_INSPECTIONMADEBY_CREATE,
		name: 'create_auxiliar_inspectionMadeBy_vhe',
		component: () => import('@/views/vhe/auxiliars_inspectionMadeBy/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nueva inspección realizada',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Tipos de documentos',
					to: VHE_AUXILIAR_INSPECTIONMADEBY_LIST,
				},
				{
					text: 'Añadir nueva inspección realizada',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_INSPECTIONMADEBY_EDIT}/:id`,
		name: 'auxiliar_inspectionMadeBy_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_inspectionMadeBy/form/formView.vue'),
		meta: {
			pageTitle: 'Editar inspección realizada',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Inspección Realizada',
					to: VHE_AUXILIAR_INSPECTIONMADEBY_LIST,
				},
				{
					text: 'Editar inspección realizada',
					active: true,
				},
			],
		},
	},
	//  END INSPECCIÓN REALIZADA POR

	// 	NIVEL 1
	{
		path: VHE_AUXILIAR_LEVEL1_LIST,
		name: 'list_auxiliar_level1_vhe',
		component: () => import('@/views/vhe/auxiliars_level1/list/listView.vue'),
		meta: {
			pageTitle: 'Listado del nivel 1',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado del nivel 1',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_LEVEL1_CREATE,
		name: 'create_auxiliar_level1_vhe',
		component: () => import('@/views/vhe/auxiliars_level1/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo nivel',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 1',
					to: VHE_AUXILIAR_LEVEL1_LIST,
				},
				{
					text: 'Añadir nuevo nivel',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_LEVEL1_EDIT}/:id`,
		name: 'auxiliar_level1_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_level1/form/formView.vue'),
		meta: {
			pageTitle: 'Editar nivel',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 1',
					to: VHE_AUXILIAR_LEVEL1_LIST,
				},
				{
					text: 'Editar nivel',
					active: true,
				},
			],
		},
	},
	//  END NIVEL 1

	// 	NIVEL 2
	{
		path: VHE_AUXILIAR_LEVEL2_LIST,
		name: 'list_auxiliar_level2_vhe',
		component: () => import('@/views/vhe/auxiliars_level2/list/listView.vue'),
		meta: {
			pageTitle: 'Listado del nivel',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado del nivel',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_LEVEL2_CREATE,
		name: 'create_auxiliar_level2_vhe',
		component: () => import('@/views/vhe/auxiliars_level2/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo nivel',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 2',
					to: VHE_AUXILIAR_LEVEL2_LIST,
				},
				{
					text: 'Añadir nuevo nivel',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_LEVEL2_EDIT}/:id`,
		name: 'auxiliar_level2_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_level2/form/formView.vue'),
		meta: {
			pageTitle: 'Editar nivel',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 2',
					to: VHE_AUXILIAR_LEVEL2_LIST,
				},
				{
					text: 'Editar nivel',
					active: true,
				},
			],
		},
	},
	//  END NIVEL 2

	// 	NIVEL 3
	{
		path: VHE_AUXILIAR_LEVEL3_LIST,
		name: 'list_auxiliar_level3_vhe',
		component: () => import('@/views/vhe/auxiliars_level3/list/listView.vue'),
		meta: {
			pageTitle: 'Listado del nivel 3',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado del nivel 3',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_LEVEL3_CREATE,
		name: 'create_auxiliar_level3_vhe',
		component: () => import('@/views/vhe/auxiliars_level3/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo nivel 3',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 3',
					to: VHE_AUXILIAR_LEVEL3_LIST,
				},
				{
					text: 'Añadir nuevo nivel 3',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_LEVEL3_EDIT}/:id`,
		name: 'auxiliar_level3_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_level3/form/formView.vue'),
		meta: {
			pageTitle: 'Editar nivel 3',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 3',
					to: VHE_AUXILIAR_LEVEL3_LIST,
				},
				{
					text: 'Editar nivel 3',
					active: true,
				},
			],
		},
	},
	//  END NIVEL 3

	// 	NIVEL 4
	{
		path: VHE_AUXILIAR_LEVEL4_LIST,
		name: 'list_auxiliar_level4_vhe',
		component: () => import('@/views/vhe/auxiliars_level4/list/listView.vue'),
		meta: {
			pageTitle: 'Listado del nivel 4',
			permission: 'view_auxiliars_vhe',
			breadcrumb: [
				{
					text: 'Listado del nivel 4',
					active: true,
				},
			],
		},
	},
	{
		path: VHE_AUXILIAR_LEVEL4_CREATE,
		name: 'create_auxiliar_level4_vhe',
		component: () => import('@/views/vhe/auxiliars_level4/form/formView.vue'),
		meta: {
			pageTitle: 'Añadir nuevo nivel 4',
			permission: 'create_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 4',
					to: VHE_AUXILIAR_LEVEL4_LIST,
				},
				{
					text: 'Añadir nuevo nivel 4',
					active: true,
				},
			],
		},
	},
	{
		path: `${VHE_AUXILIAR_LEVEL4_EDIT}/:id`,
		name: 'auxiliar_level4_edit_vhe',
		component: () => import('@/views/vhe/auxiliars_level4/form/formView.vue'),
		meta: {
			pageTitle: 'Editar nivel 4',
			permission: 'edit_vhe_providers',
			breadcrumb: [
				{
					text: 'Nivel 4',
					to: VHE_AUXILIAR_LEVEL4_LIST,
				},
				{
					text: 'Editar nivel 4',
					active: true,
				},
			],
		},
	},
	//  END NIVEL 4
]
